/**
 * customização: Wishlist via localStorage (sem contas de cliente).
 * API pública: window.DawnWishlist
 */
const WISHLIST_KEY = 'wishlist_products';
const WISHLIST_EVENT = 'wishlist:updated';

function readWishlist() {
  try {
    const raw = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    return Array.isArray(raw) ? raw : [];
  } catch (e) {
    return [];
  }
}

function writeWishlist(items) {
  try {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
  } catch (e) {
    // storage indisponível — degrada sem erro visível
  }
  document.dispatchEvent(
    new CustomEvent(WISHLIST_EVENT, {
      detail: { items },
    })
  );
}

window.DawnWishlist = {
  get() {
    return readWishlist();
  },

  has(productId) {
    const id = String(productId);
    return readWishlist().some((item) => String(item.id) === id);
  },

  add(productId, handle) {
    if (!productId) return readWishlist();
    const id = String(productId);
    const items = readWishlist().filter((item) => String(item.id) !== id);
    items.unshift({ id, handle: handle || '' });
    writeWishlist(items);
    return items;
  },

  remove(productId) {
    const id = String(productId);
    const items = readWishlist().filter((item) => String(item.id) !== id);
    writeWishlist(items);
    return items;
  },

  toggle(productId, handle) {
    if (this.has(productId)) {
      return this.remove(productId);
    }
    return this.add(productId, handle);
  },

  clear() {
    writeWishlist([]);
  },
};

// sincroniza corações em qualquer card ao mudar a wishlist
function syncAllWishlistButtons() {
  document.querySelectorAll('[data-product-card-wishlist]').forEach((button) => {
    const card = button.closest('product-card');
    if (card && typeof card.syncWishlistFromStore === 'function') {
      card.syncWishlistFromStore();
      return;
    }
    const pressed = window.DawnWishlist.has(button.dataset.productId);
    button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
  });
}

document.addEventListener(WISHLIST_EVENT, syncAllWishlistButtons);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncAllWishlistButtons);
} else {
  syncAllWishlistButtons();
}
